import EmployeeModel from "@/models/EmployeeModel";
import axiosHelper from "../axiosHelper";

export default class EmployeesApiHelper {

	_url: string = '/api/employees';

	async getEmployeesAsync(jwt: string, orderBy: string | null, orderAsc: boolean, query: string | null, positions: Array<number> | null, branches: Array<number> | null): Promise<Array<EmployeeModel>> {
		try {
			const filterObject = {
				orderBy,
				orderAsc,
				query,
				positions: positions?.join(',') ?? null,
				branches: branches?.join(',') ?? null,
			};
			const getManagersHttpClient = axiosHelper.createInstance(jwt);
			const response = await getManagersHttpClient.get(`${this._url}`, { params: filterObject });
			if (!response.data?.length) {
				return [];
			}
			return response.data.map((_: any) => new EmployeeModel(_));
		} catch (e: any) {
			console.error('Error loading employees list', e);
			return [];
		}
	}

	async getManagersAsync(jwt: string): Promise<Array<EmployeeModel>> {
		try {
			const getManagersHttpClient = axiosHelper.createInstance(jwt);
			const response = await getManagersHttpClient.get(`${this._url}/managers?orderBy=lastname&orderAsc=true`);
			if (!response.data?.length) {
				return [];
			}
			return response.data.map((_: any) => new EmployeeModel(_));
		} catch (e: any) {
			console.error('Error loading managers list', e);
			return [];
		}
	}
}